import { PAGES } from '@ats/constants';
import SettingLayout from '@layout/Setting/Setting.tsx';
import SettingPage from '@pages/Setting';
import type { RouteObject } from 'react-router';

const SettingRoute: RouteObject = {
  path: PAGES.VIDEO_INTERVIEW.SETTING.HOME,
  element: <SettingLayout />,
  children: [
    {
      index: true,
      element: <SettingPage />,
    },
  ],
};

export default SettingRoute;
